import axiosInstance from "../axios";
import { baseURLGame, AUTH, REQUEST, USER } from "../../utils/endPoints";
import { getQueryParamFromUrl } from "../../helpers/url";
import { loginAction } from "./slice";
import { otpType, userType } from "../../types/login";
import { GameStep, LoginSteps, ModalStep } from "../../types/config";
import { configAction } from "../config/slice";
import { gameAction } from "../game/slice";
import { saveTokenAsCookie } from "../../helpers/saveTokenAsCookie";
export const getPhone = function (phone: string, type: string) {
  return async (dispatch: Function) => {
    dispatch(loginAction.setRequestLoading(true));
    try {
      const config = {
        url: `${baseURLGame}${REQUEST}`,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          phone: phone,
          type: type,
        },
      };
      const response = await axiosInstance(config);
      dispatch(loginAction.setRequestData(response.data));
      if (response.status === 200) {
        dispatch(configAction.setLoginStep(LoginSteps.OTP));
      } else {
        dispatch(
          loginAction.setRequestError(
            response.data.data
              ? response.data.data.message
              : "مشکلی پیش امده لطفا مجدد تلاش کنید"
          )
        );
      }
    } catch (error) {
      dispatch(
        loginAction.setRequestError("مشکلی پیش امده لطفا مجدد تلاش کنید")
      );
      console.log(error);
    }
  };
};

export const getOTP = function (phone: string, token: string) {
  const objUrlParams = getQueryParamFromUrl();
  let data: any = { phone: phone, token: token };
  for (let key in objUrlParams) {
    if (key === "id") {
      data.invite_id = objUrlParams[key];
    }
    if (objUrlParams[key] === "harmony") {
      data.provider = objUrlParams[key];
      data.clickId = `${objUrlParams[key]}_utm_source`;
    }
  }
  return async (dispatch: Function) => {
    dispatch(loginAction.setAuthLoading(true));

    try {
      const config = {
        url: `${baseURLGame}${AUTH}`,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
      };
      const response = await axiosInstance(config);
      const authData = response.data as otpType;
      if (authData.status === "success") {
        dispatch(getUser(authData.data.token, null, true));
        dispatch(loginAction.setAuthData(authData));
        dispatch(configAction.setToken(authData.data.token));
        localStorage.setItem(
          "banimodeUserProd",
          JSON.stringify(authData.data.user)
        );
        saveTokenAsCookie(JSON.stringify(authData.data.user));
        return authData;
      } else {
        dispatch(loginAction.setAuthError(authData.message));
      }
    } catch (error) {
      console.log(error);
    }
  };
};
export const getUser = function (token: string, id = null, isAuth?: boolean) {
  const URI = id
    ? `${baseURLGame}${USER}?invite_id=${id}`
    : `${baseURLGame}${USER}`;
  return async (dispatch: Function) => {
    dispatch(loginAction.setUserLoading(true));
    try {
      const config = {
        url: URI,
        method: "GET",
        timeout: 0,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axiosInstance(config);
      dispatch(loginAction.setUserData(response.data));
      if (isAuth) {
        dispatch(configAction.setGameStep(GameStep.HOME));
        dispatch(configAction.setModalStep(ModalStep.DEFAULT));
      }
      const params = getQueryParamFromUrl();
      if (params.page === "banibon") {
        dispatch(configAction.setGameStep(GameStep.BANIBON));
      }
      if (!!params.category) {
        dispatch(configAction.setGameStep(GameStep.GAME));
      }
      if (params.page === "chance" || params.page === "cup") {
        dispatch(configAction.setGameStep(GameStep.CHANCE));
      }
      const userData = response.data as userType;
      dispatch(gameAction.setChance(userData.data?.user.chance!));
      dispatch(
        gameAction.setSpecialChance(userData.data?.user.special_chance!)
      );
    } catch (error: any) {
      dispatch(loginAction.setUserError(error));
    }
  };
};
